var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "htmlclass",
          rawName: "v-htmlclass",
          value: _vm.customHtmlClasses,
          expression: "customHtmlClasses"
        }
      ],
      staticClass: "overlay-order-box",
      class: {
        "overlay-order-box--inline": _vm.isInline
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "overlay-order-box__wrapper",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.closeOverlay.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "overlay-order-box__panel" },
            [
              _c(
                "button",
                {
                  staticClass: "overlay-order-box__close",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.closeOverlay.apply(null, arguments)
                    }
                  }
                },
                [_c("SVGClose")],
                1
              ),
              _vm._v(" "),
              _c("WidgetOrderbox", {
                ref: "orderbox",
                attrs: { "location-code": _vm.locationCode }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }